/** Shared page header — HX design language (matches the Dashboard hero). */
export function PageHeader({ eyebrow, title, subtitle, right }) {
  return (
    <div className="flex items-end justify-between gap-6 pb-6 flex-wrap">
      <div>
        {eyebrow && (
          <div className="font-mono text-[10.5px] tracking-[.16em] uppercase text-[var(--text-muted)] font-medium mb-2">
            {eyebrow}
          </div>
        )}
        <h1 className="font-display font-extrabold text-[clamp(28px,2.6vw,36px)] leading-[1.08] tracking-[-0.03em]">{title}</h1>
        {subtitle && <p className="text-[14.5px] font-medium text-[var(--text-secondary)] mt-2">{subtitle}</p>}
      </div>
      {right}
    </div>
  );
}
